import { render, staticRenderFns } from "./VisitInfo.vue?vue&type=template&id=0bc83b84&"
import script from "./VisitInfo.vue?vue&type=script&lang=ts&"
export * from "./VisitInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports